(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('td-announcement-marquee')) {
  class TDAnnouncementMarquee extends HTMLElement {
    constructor() {
      super();
      this.debouncedResize = null;
    }

    connectedCallback() {
      this.initialize();
      this.duplicateTrackIfNeeded();
      
      // Store debounced handler reference for proper removal
      this.debouncedResize = this.debounce(() => this.handleResize(), 100);
      window.addEventListener('resize', this.debouncedResize);
    }

    disconnectedCallback() {
      if (this.debouncedResize) {
        window.removeEventListener('resize', this.debouncedResize);
        this.debouncedResize = null;
      }
    }

    initialize() {
      // Count all track elements that may have been pre-rendered by Liquid
      const TRACK_ELEMENTS = this.querySelectorAll('.td-announcement-track');
      this.trackCount = TRACK_ELEMENTS.length || 1;

      // The number 10 is arbitrary
      // This component can stutter during the animation reset
      // A large size reduces stutters and delays the first until a low importance time
      this.SIZE_MULTIPLIER = 10;

      // Use the first track as the reference for cloning
      this.TRACK = TRACK_ELEMENTS[0];

      // Calculate the total width of all existing tracks
      this.trackWidth = 0;
      if (this.TRACK) {
        const SINGLE_TRACK_WIDTH = this.TRACK.offsetWidth;
        this.trackWidth = SINGLE_TRACK_WIDTH * this.trackCount;
      }
    }

    duplicateTrackIfNeeded() {
      // This check prevents infinite duplication
      if (!this.TRACK || this.trackWidth === 0) {
        console.warn('TDAnnouncementMarquee: Track width is zero or track element not found. Cannot duplicate track.');
        return;
      }

      const originalTrackWidth = this.TRACK.offsetWidth;
      
      // Validate originalTrackWidth to prevent infinite loop if element is hidden/not rendered
      if (originalTrackWidth === 0) {
        console.warn('TDAnnouncementMarquee: Original track width is zero. Element may be hidden or not rendered. Cannot duplicate track.');
        return;
      }

      // Safety counter to prevent infinite loops
      const MAX_ITERATIONS = 250;
      let iterations = 0;

      while (this.trackWidth < window.innerWidth * this.SIZE_MULTIPLIER) {
        // Safety check to prevent infinite loops
        if (iterations >= MAX_ITERATIONS) {
          console.error('TDAnnouncementMarquee: Maximum iterations reached. Stopping to prevent infinite loop.');
          break;
        }

        const newTrack = this.TRACK.cloneNode(true);
        newTrack.setAttribute('aria-hidden', 'true');
        this.TRACK.parentNode.appendChild(newTrack);
        this.trackWidth += originalTrackWidth;
        this.trackCount++;
        iterations++;
      }

      this.style.setProperty('--track-count', this.trackCount);
    }

    handleResize() {
      this.duplicateTrackIfNeeded();
    }

    debounce(func, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }
  }

  customElements.define('td-announcement-marquee', TDAnnouncementMarquee);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-faq"] && !Shopify.designMode) return;
  try {
    
/**
 * TD FAQ Accordion Component
 * Handles FAQ accordion interactions with proper accessibility
 */
if (!customElements.get('td-faq-accordion')) {
  class TdFaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.buttons = [];
      this.viewMoreButton = null;
      this.isExpanded = false;

      /* Store bound handlers for proper cleanup */
      this.boundHandleToggle = this.handleToggle.bind(this);
      this.boundHandleKeydown = this.handleKeydown.bind(this);
      this.boundHandleViewMore = this.handleViewMore.bind(this);
    }

    connectedCallback() {
      this.buttons = [...this.querySelectorAll('.td-faq__question')];
      this.viewMoreButton = this.closest('.td-faq__container')?.querySelector('[data-view-more]');
      
      this.initializeAccordion();
      this.initializeViewMore();
    }

    disconnectedCallback() {
      this.buttons.forEach(button => {
        button.removeEventListener('click', this.boundHandleToggle);
        button.removeEventListener('keydown', this.boundHandleKeydown);
      });

      if (this.viewMoreButton) {
        this.viewMoreButton.removeEventListener('click', this.boundHandleViewMore);
      }
    }

    initializeAccordion() {
      this.buttons.forEach(button => {
        button.addEventListener('click', this.boundHandleToggle);
        button.addEventListener('keydown', this.boundHandleKeydown);
      });
    }

    initializeViewMore() {
      if (!this.viewMoreButton) return;
      this.viewMoreButton.addEventListener('click', this.boundHandleViewMore);
    }

    handleToggle(event) {
      const button = event.currentTarget;
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const panelId = button.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);

      if (!panel) return;

      button.setAttribute('aria-expanded', !isExpanded);
      panel.setAttribute('aria-hidden', isExpanded);
    }

    handleKeydown(event) {
      const { key } = event;
      const currentIndex = this.buttons.indexOf(event.currentTarget);

      let targetIndex = -1;

      switch (key) {
        case 'ArrowDown':
          event.preventDefault();
          targetIndex = (currentIndex + 1) % this.buttons.length;
          break;
        case 'ArrowUp':
          event.preventDefault();
          targetIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
          break;
        case 'Home':
          event.preventDefault();
          targetIndex = 0;
          break;
        case 'End':
          event.preventDefault();
          targetIndex = this.buttons.length - 1;
          break;
        case 'Escape':
          const panel = document.getElementById(event.currentTarget.getAttribute('aria-controls'));
          if (panel && panel.getAttribute('aria-hidden') === 'false') {
            event.currentTarget.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
          }
          break;
      }

      if (targetIndex >= 0) {
        this.buttons[targetIndex].focus();
      }
    }

    handleViewMore() {
      const hiddenItems = [...this.querySelectorAll('.td-faq__item--hidden-mobile')];
      const viewMoreContainer = this.viewMoreButton.closest('.td-faq__view-more');
      
      // Fade out button first
      if (viewMoreContainer) {
        viewMoreContainer.classList.add('td-faq__view-more--hiding');
      }

      // Stagger reveal items with animation
      hiddenItems.forEach((item, index) => {
        setTimeout(() => {
          item.classList.remove('td-faq__item--hidden-mobile');
          item.classList.add('td-faq__item--revealing');
          
          // Remove animation class after it completes
          item.addEventListener('animationend', () => {
            item.classList.remove('td-faq__item--revealing');
          }, { once: true });
        }, index * 80);
      });

      // Hide button after all items revealed
      setTimeout(() => {
        viewMoreContainer?.classList.add('td-faq__view-more--hidden');
      }, hiddenItems.length * 80 + 100);
    }
  }

  customElements.define('td-faq-accordion', TdFaqAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-header"] && !Shopify.designMode) return;
  try {
    
/**
 * TD Header Component
 * Handles mobile menu drawer, dropdown interactions, and sticky header
 */

 if (!customElements.get('td-header-component')) {
  class TdHeaderComponent extends HTMLElement {
    constructor() {
      super();

      // Constants
      this.HEADER_GROUP_SELECTOR = '#header-group';
      this.ANNOUNCEMENT_BAR_SELECTOR = '.td-announcement-bar';
      this.CSS_VAR_NAME = '--td-announcement-bar-height';
      
      // Cache DOM elements
      this.menuToggle = this.querySelector('[data-td-menu-toggle]');
      this.mobileMenu = this.querySelector('[data-td-mobile-menu]');
      this.menuClose = this.querySelector('[data-td-menu-close]');
      this.menuBackdrop = this.querySelector('[data-td-menu-backdrop]');
      this.dropdownToggles = this.querySelectorAll('[data-td-dropdown-toggle]');
      
      // Track scroll updates for performance
      this.scrollRafId = null;
      
      // Bind methods
      this.openMobileMenu = this.openMobileMenu.bind(this);
      this.closeMobileMenu = this.closeMobileMenu.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleDropdownHover = this.handleDropdownHover.bind(this);
      this.updateAnnouncementBarHeight = this.updateAnnouncementBarHeight.bind(this);
      this.updateMegaMenuPosition = this.updateMegaMenuPosition.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }
    
    connectedCallback() {
      this.setupEventListeners();
      this.updateAnnouncementBarHeight();
      window.addEventListener('resize', this.updateAnnouncementBarHeight);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }
    
    disconnectedCallback() {
      this.removeEventListeners();
      window.removeEventListener('resize', this.updateAnnouncementBarHeight);
      window.removeEventListener('scroll', this.handleScroll);
      
      // Restore scrolling if mobile menu was open when component is removed
      if (this.mobileMenu && this.mobileMenu.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
    }
    
    setupEventListeners() {
      // Mobile menu toggle
      if (this.menuToggle) {
        this.menuToggle.addEventListener('click', this.openMobileMenu);
      }
      
      // Mobile menu close
      if (this.menuClose) {
        this.menuClose.addEventListener('click', this.closeMobileMenu);
      }
      
      // Backdrop click
      if (this.menuBackdrop) {
        this.menuBackdrop.addEventListener('click', this.closeMobileMenu);
      }
      
      // Keyboard events
      document.addEventListener('keydown', this.handleKeydown);
      
      // Desktop dropdown hover/focus
      this.dropdownToggles.forEach((toggle) => {
        const parent = toggle.closest('.td-header__nav-item');
        if (parent) {
          parent.addEventListener('mouseenter', () => this.handleDropdownHover(toggle, true));
          parent.addEventListener('mouseleave', () => this.handleDropdownHover(toggle, false));
          toggle.addEventListener('focus', () => this.handleDropdownHover(toggle, true));
          toggle.addEventListener('blur', (e) => {
            // Check if focus is moving to dropdown content
            setTimeout(() => {
              if (!parent.contains(document.activeElement)) {
                this.handleDropdownHover(toggle, false);
              }
            }, 10);
          });
        }
      });
    }
    
    removeEventListeners() {
      if (this.menuToggle) {
        this.menuToggle.removeEventListener('click', this.openMobileMenu);
      }
      
      if (this.menuClose) {
        this.menuClose.removeEventListener('click', this.closeMobileMenu);
      }
      
      if (this.menuBackdrop) {
        this.menuBackdrop.removeEventListener('click', this.closeMobileMenu);
      }
      
      document.removeEventListener('keydown', this.handleKeydown);
    }

    updateAnnouncementBarHeight() {
      const headerGroup = document.querySelector(this.HEADER_GROUP_SELECTOR);
      const announcementBar = document.querySelector(this.ANNOUNCEMENT_BAR_SELECTOR);
      if (!headerGroup) return;

      const height = announcementBar ? announcementBar.offsetHeight : 0;
      headerGroup.style.setProperty(this.CSS_VAR_NAME, height + 'px');

      // Update mega menu position using the same method for consistency
      // This ensures both initial load and resize events use accurate positioning
      this.updateMegaMenuPosition();
    }
    
    openMobileMenu() {
      if (!this.mobileMenu) return;
      
      this.mobileMenu.classList.add('is-open');
      
      if (this.menuToggle) {
        this.menuToggle.setAttribute('aria-expanded', 'true');
      }
      
      document.body.style.overflow = 'hidden';
      
      // Focus trap - focus first focusable element
      const firstFocusable = this.mobileMenu.querySelector('button, a, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) {
        setTimeout(() => firstFocusable.focus(), 100);
      }
      
      // Dispatch custom event
      this.dispatchEvent(new CustomEvent('td:menu:open', { bubbles: true }));
    }
    
    closeMobileMenu() {
      if (!this.mobileMenu) return;
      
      this.mobileMenu.classList.remove('is-open');
      
      if (this.menuToggle) {
        this.menuToggle.setAttribute('aria-expanded', 'false');
      }
      
      document.body.style.overflow = '';
      
      // Return focus to toggle
      if (this.menuToggle) {
        this.menuToggle.focus();
      }
      
      // Dispatch custom event
      this.dispatchEvent(new CustomEvent('td:menu:close', { bubbles: true }));
    }
    
    handleKeydown(event) {
      // Close mobile menu on Escape
      if (event.key === 'Escape') {
        if (this.mobileMenu && this.mobileMenu.classList.contains('is-open')) {
          this.closeMobileMenu();
        }
        
        // Close any open dropdowns
        this.dropdownToggles.forEach((toggle) => {
          toggle.setAttribute('aria-expanded', 'false');
        });
      }
    }
    
    handleScroll() {
      // Throttle scroll updates for performance
      if (this.scrollRafId) {
        cancelAnimationFrame(this.scrollRafId);
      }
      
      this.scrollRafId = requestAnimationFrame(() => {
        this.updateMegaMenuPosition();
        this.scrollRafId = null;
      });
    }

    updateMegaMenuPosition() {
      /**
       * Updates mega menu position based on header's current viewport position.
       * Uses getBoundingClientRect() for accurate positioning that accounts for:
       * - Scroll position
       * - Sticky positioning
       * - Dynamic header height changes
       * 
       * Also sets --td-header-height as a fallback for initial CSS positioning
       * before JavaScript executes.
       */
      const header = this.querySelector('.td-header');
      if (!header) return;

      const headerRect = header.getBoundingClientRect();
      const newTop = headerRect.bottom;
      
      // Primary: Dynamic position based on viewport (accounts for scroll/sticky)
      document.documentElement.style.setProperty('--td-mega-menu-top', newTop + 'px');
      
      // Fallback: Static height calculation for initial CSS positioning
      // This is used as a fallback in CSS before JS executes
      const announcementBar = document.querySelector(this.ANNOUNCEMENT_BAR_SELECTOR);
      const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
      const headerBottom = announcementHeight + header.offsetHeight;
      header.style.setProperty('--td-header-height', headerBottom + 'px');
    }

    handleDropdownHover(toggle, isOpen) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      // Update mega dropdown position based on header's current position
      if (isOpen) {
        const dropdown = toggle.nextElementSibling;
        if (dropdown && dropdown.classList.contains('td-header__dropdown--mega')) {
          // Update CSS variable immediately when opening
          this.updateMegaMenuPosition();
        }
      }
    }
  }
  
  customElements.define('td-header-component', TdHeaderComponent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('td-marquee')) {
  class TDMarquee extends HTMLElement {
    constructor() {
      super();
      this.debouncedResize = null;
      this.isBannerMode = this.dataset.bannerMode === 'true';
      this.DESKTOP_BREAKPOINT = 990;
    }

    connectedCallback() {
      this.initialize();
      this.duplicateTrackIfNeeded();
      
      // Store debounced handler reference for proper removal
      this.debouncedResize = this.debounce(() => this.handleResize(), 100);
      window.addEventListener('resize', this.debouncedResize);
    }

    disconnectedCallback() {
      if (this.debouncedResize) {
        window.removeEventListener('resize', this.debouncedResize);
        this.debouncedResize = null;
      }
    }

    initialize() {
      // Count all track elements that may have been pre-rendered by Liquid
      const TRACK_ELEMENTS = this.querySelectorAll('.td-marquee__track');
      this.trackCount = TRACK_ELEMENTS.length || 1;

      // The number 10 is arbitrary
      // This component can stutter during the animation reset
      // A large size reduces stutters and delays the first until a low importance time
      this.SIZE_MULTIPLIER = 10;

      // Use the first track as the reference for cloning
      this.TRACK = TRACK_ELEMENTS[0];

      // Calculate the total width of all existing tracks
      this.trackWidth = 0;
      if (this.TRACK) {
        const SINGLE_TRACK_WIDTH = this.TRACK.offsetWidth;
        this.trackWidth = SINGLE_TRACK_WIDTH * this.trackCount;
      }
    }

    isDesktop() {
      return window.innerWidth >= this.DESKTOP_BREAKPOINT;
    }

    shouldSkipDuplication() {
      // Skip duplication if banner mode is enabled and we're on desktop
      return this.isBannerMode && this.isDesktop();
    }

    duplicateTrackIfNeeded() {
      // Skip if in banner mode on desktop
      if (this.shouldSkipDuplication()) {
        this.style.setProperty('--track-count', 1);
        return;
      }

      // This check prevents infinite duplication
      if (!this.TRACK || this.trackWidth === 0) {
        console.warn('TDMarquee: Track width is zero or track element not found. Cannot duplicate track.');
        return;
      }

      const originalTrackWidth = this.TRACK.offsetWidth;

      // Guard against infinite loop if element is hidden (e.g., collapsed accordion, display:none)
      // offsetWidth returns 0 for hidden elements, so adding 0 would never satisfy the exit condition
      if (originalTrackWidth === 0) {
        return;
      }

      while (this.trackWidth < window.innerWidth * this.SIZE_MULTIPLIER) {
        const newTrack = this.TRACK.cloneNode(true);
        newTrack.setAttribute('aria-hidden', 'true');
        this.TRACK.parentNode.appendChild(newTrack);
        this.trackWidth += originalTrackWidth;
        this.trackCount++;
      }

      this.style.setProperty('--track-count', this.trackCount);
    }

    handleResize() {
      // Always call duplicateTrackIfNeeded - it handles both banner mode
      // (resets --track-count to 1) and marquee mode (adds tracks if needed)
      this.duplicateTrackIfNeeded();
    }

    debounce(func, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }
  }

  customElements.define('td-marquee', TDMarquee);
}

  } catch(e) { console.error(e); }
})();
})();
